import React from 'react';
import clsx from "clsx";
import ShowArticleCostsButtonRowProperties from './ShowArticleCostsButtonRowProperties';
import { useStyles } from '../ShowArticleCostsButton.style';
import ShowText from '../../../Info/ShowText/ShowText';
import Article from '../../../../entities/Article';
import ShowPrice from '../../../Info/ShowPrice/ShowPrice';
import ShowDeliveryTime from '../../../Info/ShowDeliveryTime/ShowDeliveryTime';
import Currency from '../../../../entities/Currency';

const ShowArticleCostsButtonRowSmall: React.FC<ShowArticleCostsButtonRowProperties> = ({
    articleId,
    prices,
    articles
}) => {
    const classes = useStyles();
    const article = articles.find((t: Article) => t.id === articleId);

    return (
        <div className={clsx(classes.show_article_price_info_container_small)}>
            <div className={classes.article_header_small}>
                <ShowText text={article?.name ?? ''} />
            </div>
            
            <div className={classes.prices_container_small}>
                {prices.map((price, index) => (
                    <div key={index} className={classes.price_and_delivery_item_small}>
                        <ShowPrice 
                            value={price.salePrice} 
                            currency={Currency.DOLLAR}
                        />
                        <ShowDeliveryTime 
                            deliveryTime={price.deliveryTimeDays}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ShowArticleCostsButtonRowSmall;
